import superagentWithRetries from './superagentWithRetries'


const GEO_REQUEST_RETRY_COUNT = 2
const GEO_REQUEST_RETRY_DELAY = 2000

export default superagentWithRetries(GEO_REQUEST_RETRY_COUNT, GEO_REQUEST_RETRY_DELAY)
